module.exports = __webpack_public_path__ + "img/person_type4.9c0ca5c4.png";